import { DecimalPipe } from '@angular/common';
import { DateFormat } from '@reg/shared/enum';
import { convertToDateTime } from '@reg/shared/helper/dateTime-helper';
import { format } from 'date-fns';

/**
 * Model to hold a body fat loss date range
 */
export class BodyFatLossDateRange {
    public startDate: Date = null;
    public endDate: Date = null;
    public dailyBodyFatLossPercentage: number = null;

    public isEmpty(): boolean {
        return (!this.startDate && !this.endDate && !this.dailyBodyFatLossPercentage);
    }

    public clone(): BodyFatLossDateRange {
        const clone: BodyFatLossDateRange = new BodyFatLossDateRange();
        clone.startDate = this.startDate && new Date(this.startDate);
        clone.endDate = this.endDate && new Date(this.endDate);
        clone.dailyBodyFatLossPercentage = this.dailyBodyFatLossPercentage;

        return clone;
    }

    public serialize(): any {
        const dailyBfLossPct: number = this.dailyBodyFatLossPercentage &&
            parseFloat(this.dailyBodyFatLossPercentage.toString()) / 100;

        return {
            startDate: this.startDate ? format(this.startDate, DateFormat.YYYYMMDD) : null,
            endDate: this.endDate ? format(this.endDate, DateFormat.YYYYMMDD) : null,
            dailyBodyFatLossPercentage: dailyBfLossPct || null,
        };
    }

    /**
     * @param json
     * @returns {BodyFatLossDateRange}
     */
    public deserialize(json: any): BodyFatLossDateRange {
        if (!json) {
            return;
        }

        this.startDate = json.startDate ? convertToDateTime(json.startDate) : null;
        this.endDate = json.endDate ? convertToDateTime(json.endDate) : null;

        if (json.dailyBodyFatLossPercentage) {
            const decimalPipe: DecimalPipe = new DecimalPipe('en-US');
            this.dailyBodyFatLossPercentage = parseFloat(
                decimalPipe.transform(json.dailyBodyFatLossPercentage * 100, '1.2-2'),
            );
        }

        return this;
    }
}
